<script>
  import * as restfulService from '../../app/services/restfulService'

  import bus from '@utils/bus'

  export default {
    data () {
      return {
        registrationId: null
      }
    },
    mounted () {
      restfulService.post('registration', 'my', null, {})
        .then(response => {
          let congrega = response.filter(item => item.main_event.id === 277)
          if (congrega.length) {
            this.registrationId = congrega[0].id
          }
          bus.$emit('hide-loader')
        })
        .catch(e => {
          bus.$emit('hide-loader')
          console.log(e)
        })
    }
  }
</script>

<template>
    <div>
        <div class="event-actions">
            <router-link :to="{ name: 'registration.home' }"
                         class="-button1"
                         title="Nova Inscrição">
                <i class="fa fa-plus"></i>
                <span>Nova Inscrição</span>
            </router-link>
            <router-link :to="{ name: 'submission.home' }"
                         class="-button3"
                         title="Submissões">
                <i class="fa fa-file-o"></i>
                <span>Nova Submissão</span>
            </router-link>
            <router-link :to="{ name: 'registration.show', params: {id: registrationId, tab: 'short-courses'} }"
                         v-if="registrationId"
                         class="-button4"
                         title="Minicursos">
                <i class="fa fa-calendar"></i>
                <span>Nova Inscrição em Oficinas/Minicursos</span>
            </router-link>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .logo {
        display: block;
        width: 70%;
        margin: 0 auto;
        padding: 60px 0 20px;
        img {
            display: block;
            margin: 0 auto;
            max-width: 100%;
            max-height: 100px;
        }
    }

    .page-title {
        text-align: center;
        color: #919191;
        font-size: 38px;
        letter-spacing: -1px;
        font-weight: 200;
    }

    .event-actions {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 60px;
        > a {
            width: 38%;
            text-decoration: none;
            padding: 80px 5px;
            margin: 0 5% 5%;
            text-align: center;
            border-radius: 4px;
            border: 1px solid #e7e7e7;
            border-bottom-width: 10px;
            transition: all .3s ease-in-out;

            i, span {
                display: inline-block;
                width: 100%;
                color: #FFF;
            }
            i {
                font-size: 46px;
                color: rgba(0, 0, 0, .3);
                transition: all .3s ease-in-out;
            }
            span {
                font-family: 'Roboto', sans-serif;
                padding-top: 20px;
                font-size: 24px;
                font-weight: lighter;
                text-transform: uppercase;
                color: #8a8a8a;
                transition: all .3s ease-in-out;
            }

            &.-button1 {
                border-bottom-color: #0E9DD9;
                i {
                    color: #0E9DD9;
                }
                &:hover {
                    background-color: #0E9DD9;
                    border-bottom-color: #0c82b3;
                    i {
                        color: rgba(0, 0, 0, .4);
                    }
                    span {
                        color: #FFF;
                    }
                }
            }
            &.-button2 {
                border-bottom-color: #74726d;
                i {
                    color: #74726d;
                }
                &:hover {
                    background-color: #74726d;
                    border-bottom-color: #54534f;
                    i {
                        color: rgba(0, 0, 0, .4);
                    }
                    span {
                        color: #FFF;
                    }
                }
            }
            &.-button3 {
                border-bottom-color: #A384B7;
                i {
                    color: #A384B7;
                }
                &:hover {
                    background-color: #A384B7;
                    border-bottom-color: #856b95;
                    i {
                        color: rgba(0, 0, 0, .4);
                    }
                    span {
                        color: #FFF;
                    }
                }
            }
            &.-button4 {
                border-bottom-color: #EE6A5C;
                i {
                    color: #EE6A5C;
                }
                &:hover {
                    background-color: #EE6A5C;
                    border-bottom-color: #d25e51;
                    i {
                        color: rgba(0, 0, 0, .4);
                    }
                    span {
                        color: #FFF;
                    }
                }
            }
            &.-button5 {
                border-bottom-color: #E58432;
                i {
                    color: #E58432;
                }
                &:hover {
                    background-color: #E58432;
                    border-bottom-color: #c5722b;
                    i {
                        color: rgba(0, 0, 0, .4);
                    }
                    span {
                        color: #FFF;
                    }
                }
            }
        }
    }

    @media all and (max-width: 960px) {
        .logo {
            width: auto;
            padding: 30px 0 10px;
        }
        .page-title {
            font-size: 30px;
        }
        .event-actions {
            padding: 30px;
            flex-wrap: wrap;
            > a {
                width: 46%;
                margin-left: 2%;
                margin-right: 2%;
                margin-bottom: 20px;
                span {
                    padding-top: 10px;
                    font-size: 20px;
                }
            }
        }
    }

    @media all and (max-width: 768px) {
        .logo {
            width: 60%;
        }
        .event-actions {
            padding: 30px 10px;
        }
    }

    @media all and (max-width: 520px) {
        .event-actions > a {
            width: 100%;
            margin: 0 0 15px 0;
            padding: 30px 5px;
        }
    }
</style>
